module.exports = __webpack_public_path__ + "static/media/Slice13@2x.2a3b9b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Slice13@2x.png
// module id = 1737
// module chunks = 0